import { Injectable } from '@angular/core';

import { PlatformService } from '@core/services/util/platform.service';

@Injectable({
    providedIn: 'root'
})
export class SessionStorageService {

    constructor(
        private platformService: PlatformService
    ) { }

    get(key: string) {
        if (this.platformService.isServer()) { return undefined; }
        try {
            const data = sessionStorage.getItem(key);
            return JSON.parse(data);
        }
        catch (e) {
            return undefined;
        }
    }

    set(key: string, data: any) {
        if (this.platformService.isServer()) { return undefined; }
        try {
            sessionStorage.setItem(key, JSON.stringify(data));
            return data;
        }
        catch (e) {
            return undefined;
        }
    }

    remove(key: string) {
        if (this.platformService.isServer()) { return undefined; }
        try {
            return sessionStorage.removeItem(key);
        }
        catch (e) {
            return undefined;
        }
    }

}
